/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spotting patterns in dense grids of numbers — gene-expression matrices, correlation tables, activity-by-hour grids — where clusters and outliers are hard to see in raw figures.`)
};

const es_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para detectar patrones en cuadrículas densas de números — matrices de expresión génica, tablas de correlación, cuadrículas de actividad por hora — donde las agrupaciones y valores atípicos son difíciles de ver en cifras en bruto.`)
};

const de_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Erkennen von Mustern in dichten Zahlengittern — Genexpressionsmatrizen, Korrelationstabellen, Aktivität-nach-Stunde-Gitter —, bei denen Cluster und Ausreißer in rohen Zahlen schwer zu erkennen sind.`)
};

const nl_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het opsporen van patronen in dichte rasters van getallen — genexpressiematrices, correlatietabellen, activiteit-per-uur-rasters — waarbij clusters en uitschieters moeilijk te zien zijn in ruwe cijfers.`)
};

const fr_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À repérer des motifs dans des grilles denses de nombres — matrices d'expression génique, tableaux de corrélation, grilles d'activité par heure — où les regroupements et valeurs aberrantes sont difficiles à voir dans des chiffres bruts.`)
};

const it_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A individuare schemi in griglie dense di numeri — matrici di espressione genica, tabelle di correlazione, griglie di attività per ora — dove cluster e valori anomali sono difficili da vedere nei numeri grezzi.`)
};

const pt_br2_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para identificar padrões em grades densas de números — matrizes de expressão gênica, tabelas de correlação, grades de atividade por hora — em que agrupamentos e valores discrepantes são difíceis de ver em números brutos.`)
};

const pt_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Para detetar padrões em grelhas densas de números — matrizes de expressão génica, tabelas de correlação, grelhas de atividade por hora — onde os agrupamentos e valores atípicos são difíceis de ver em valores brutos.`)
};

const ja_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密な数値グリッド — 遺伝子発現行列、相関表、時間帯別活動グリッドなど — の中のパターンを見つけるのに向いています。生の数字ではクラスターや外れ値が見えにくい場合に有効です。`)
};

const zh_heat_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合在密集的数字网格中发现模式——例如基因表达矩阵、相关性表格、按小时统计的活动网格——这些模式在原始数字中很难看出。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const heat_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.heat_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("heat_faq_a3", locale)
	if (locale === "en") return en_heat_faq_a3(inputs)
	if (locale === "es") return es_heat_faq_a3(inputs)
	if (locale === "de") return de_heat_faq_a3(inputs)
	if (locale === "nl") return nl_heat_faq_a3(inputs)
	if (locale === "fr") return fr_heat_faq_a3(inputs)
	if (locale === "it") return it_heat_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_heat_faq_a3(inputs)
	if (locale === "pt") return pt_heat_faq_a3(inputs)
	if (locale === "ja") return ja_heat_faq_a3(inputs)
	return zh_heat_faq_a3(inputs)
};